(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-dropdown"] && !Shopify.designMode) return;
  try {
    (function ($) {
    var doLog = false;

    $.fn.mySelectDropdown = function () {
      return this.each(function () {
        var $select = $(this);
        if ($select.data('initialized')) return;
        $select.data('initialized', true);

        buildDropdown($select);
        bindEvents($select);
      });
    };

    /* -------------------- BUILD -------------------- */
    function buildDropdown($select) {
      var $wrapper = $('<div class="f-dropdown selectDropdown" />');
      if ($select.is(':disabled')) $wrapper.addClass('disabled');

      $select.wrap($wrapper);

      var placeholder = $select.attr('placeholder') || '';
      var $label = $('<span tabindex="0" />').append($('<span class="main" />').append($('<span />').text(placeholder))).insertAfter($select);

      var $list = $('<ul />').insertAfter($select);

      $select.find('option').each(function () {
        var $opt = $(this);
        if (!$opt.val()) return;

        var $a = $('<a />', {
          'data-val': $opt.val(),
        });

        // Create wrapper span with main class
        var $wrapper = $('<span />', {
          'class': 'main'
        });

        var image = $opt.data('image');
        if (image) {
          $wrapper.append($('<img />', { src: image }));
        }

        // Append text span
        $wrapper.append(
          $('<span />').text($opt.text())
        );

        // Append wrapper to anchor
        $a.append($wrapper);

        $('<li />').append($a).appendTo($list);
      });

      // syncFromSelect($select);
    }

    function syncFromSelect($select) {
      var $wrapper = $select.parent();
      var $selected = $select.find('option:selected');

      if ($selected.length && $selected.val()) {
        var value = $selected.val();
        var $match = $wrapper.find('a[data-val="' + value + '"]');

        $wrapper.addClass('filled');
        $wrapper.find('li').removeClass('active');
        $match.parent().addClass('active');
        $wrapper.children('span').html($match.html());
      }
    }

    /* -------------------- EVENTS -------------------- */
    function bindEvents($select) {
      var $wrapper = $select.parent();
      if ($select.is(':disabled')) return;

      // Click option
      $wrapper.on('click', 'ul li a', function (e) {
        e.preventDefault();
        selectItem($wrapper, $(this));
      });

      // Toggle open
      $wrapper.on('click', '> span', function () {
        $wrapper.toggleClass('open');
      });

      // Close outside
      $(document).on('click touchstart', function (e) {
        if (!$wrapper.is(e.target) && !$wrapper.has(e.target).length) {
          $wrapper.removeClass('open');
        }
      });

      // Keyboard
      $(document).on('keydown', function (e) {
        handleKeydown(e, $wrapper);
      });
    }

    /* -------------------- SELECT LOGIC -------------------- */
    function selectItem($wrapper, $link) {
      var $select = $wrapper.find('select.f-dropdown');
      var value = $link.data('val');
      var isActive = $link.parent().hasClass('active');

      $wrapper.find('li').removeClass('active');

      if (isActive) {
        $select.val('');
        $wrapper.removeClass('filled');
        $wrapper.children('span').text($select.attr('placeholder'));
      } else {
        $select.val(value);
        $link.parent().addClass('active');
        $wrapper.addClass('filled');
        $wrapper.children('span').html($link.html());
      }

      triggerCustomChange($select);
      $wrapper.removeClass('open');
    }

    function triggerCustomChange($select) {
      var selectEl = $select[0]; // get DOM element

      var event = new Event('change', {
        bubbles: true
      });

      event.custom = true; // optional flag
      selectEl.dispatchEvent(event);
    }

    /* -------------------- KEYBOARD -------------------- */
    function handleKeydown(e, $wrapper) {
      var $label = $wrapper.children('span');
      if (!$label.is(':focus')) return;

      var $listItems = $wrapper.find('li');
      var $active = $wrapper.find('li.active');
      var index = $listItems.index($active);
      var max = $listItems.length - 1;

      switch (e.key) {
        case 'Tab':
          $wrapper.removeClass('open');
          return;

        case 'Escape':
          $wrapper.removeClass('open');
          return;

        case 'Enter':
          e.preventDefault();
          $wrapper.toggleClass('open');
          return;

        case 'ArrowUp':
          e.preventDefault();
          index = Math.max(0, index - 1);
          break;

        case 'ArrowDown':
          e.preventDefault();
          index = Math.min(max, index + 1);
          break;

        case 'Home':
          e.preventDefault();
          index = 0;
          break;

        case 'End':
          e.preventDefault();
          index = max;
          break;

        default:
          return;
      }

      var $target = $listItems.eq(index).find('a');
      selectItem($wrapper, $target);
      scrollIntoView($listItems.eq(index), $wrapper.find('ul'));
    }

    function scrollIntoView($child, $parent) {
      if (!$child.length) return;

      var rectChild = $child[0].getBoundingClientRect();
      var rectParent = $parent[0].getBoundingClientRect();

      if (rectChild.bottom > rectParent.bottom) {
        $child[0].scrollIntoView(false);
      }
      if (rectChild.top < rectParent.top) {
        $child[0].scrollIntoView();
      }
    }
  })(jQuery);

  $('select.f-dropdown').mySelectDropdown();
  } catch(e) { console.error(e); }
})();

})();
